import { render, staticRenderFns } from "./MenuV2.vue?vue&type=template&id=316be39a&scoped=true"
import script from "./MenuV2.vue?vue&type=script&lang=js"
export * from "./MenuV2.vue?vue&type=script&lang=js"
import style0 from "./MenuV2.vue?vue&type=style&index=0&id=316be39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316be39a",
  null
  
)

export default component.exports